import { useCallback } from 'react';

import { useStarterDashboardPageData } from '#src/app/pages/starterDashboard/pageContext';

import { useDownloadFlyerModal } from './useDownloadFlyerModal';

type Context = 'starter_dashboard_task' | 'starter_dashboard_grow_petition';

export function useTriggerDownloadFlyerModal(context: Context): () => Promise<void> {
	const {
		data: { petition },
	} = useStarterDashboardPageData();

	const openDownloadFlyerModal = useDownloadFlyerModal();

	const triggerDownloadFlyerModal = useCallback(async () => {
		return openDownloadFlyerModal({
			petition,
			context,
		}).waitForResult();
	}, [openDownloadFlyerModal, petition, context]);

	return triggerDownloadFlyerModal;
}
